import { render, staticRenderFns } from "./CreateBonusRateComponent.vue?vue&type=template&id=18c8cbb3&scoped=true"
import script from "./CreateBonusRateComponent.vue?vue&type=script&lang=js"
export * from "./CreateBonusRateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8cbb3",
  null
  
)

export default component.exports